import React from 'react'
import { useSelector } from 'react-redux'

const CartUpsells = (data) => {
  const { upsells } = useSelector((state) => state.cart)

  return (
    <div className={`related-products related-products--cartdrawer border-t border-[rgba(33,33,33,0.25)] pt-6 pb-6 relative overflow-hidden !opacity-100 lg:-mr-1 lg:pr-1 ${upsells.length > 0 ? '' : 'hidden'}`}>
      {data.data.recommendationHeading && <h3 className='text-base text-black mb-6' dangerouslySetInnerHTML={{ __html: data.data.recommendationHeading }} />}
      <div data-inline-cart-swiper>
        {upsells.length > 1 && <button className="swiper-button-prev !text-second !h-auto after:!hidden !top-6 !right-12 !mt-0 !left-auto !hidden lg:!flex focus-visible:outline focus:outline" dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-arrow'] }} />}
        {upsells.length > 1 && <button className="swiper-button-next !text-second !h-auto after:!hidden !top-6 !right-1 !mt-0 !left-auto !hidden lg:!flex focus-visible:outline focus:outline" dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-arrow-right'] }} />}
        <div className={`swiper-wrapper !static ${data.data.xgenId ? 'XGen_SmartElement' : ''}`} id={`XSE-${data.data.xgenId}`}>
            {
            upsells.map((product, index) =>
                <div className="swiper-slide" key={`cart-rec-${product.id}-${index}`}>
                <div className="h-full" product-tile="true" props={JSON.stringify({...product, context: 'cart-drawer'}).replace("'", "'")}></div>
                </div>
            )
            }
        </div>
      </div>
    </div>
  )
}

export default CartUpsells